import React, { useEffect } from 'react'

type Handler = (event: MouseEvent) => void

export function useOnClickOutside(ref: React.RefObject<HTMLElement>, handler: Handler, additionalRef?: React.RefObject<HTMLElement>): void {
  useEffect(() => {
    const listener = (event: any) => {
      if (ref.current && !ref.current.contains(event.target) && (additionalRef?.current ? !additionalRef.current.contains(event.target) : true)) {
        handler(event)
      }
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler, additionalRef])
}

